/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';

import { Container, Select } from './styles';

export interface IOptions {
  id: number | string;
  value: string;
}

interface IProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  placeholder?: string;
  options: Array<IOptions>;
  setValue: (value: string) => void;
  sizeDisplay?: 'lg' | 'md' | 'sm';
}

const StyledSelect = ({
  options,
  placeholder,
  setValue,
  sizeDisplay = 'lg',
  value,
  ...rest
}: IProps) => (
  <Container sizeDisplay={sizeDisplay}>
    <Select
      onChange={(event) => setValue(event.target.value)}
      value={value}
      {...rest}
    >
      {placeholder ? <option value="">{placeholder}</option> : null}
      {options?.map((option) => (
        <option key={option.id} value={option.id}>
          {option.value}
        </option>
      ))}
    </Select>
  </Container>
);

export { StyledSelect };
